export default "__VITE_ASSET__CwW5Zq_C__"